export enum APP_LANGUAGE {
  EN = 'en',
  UK = 'uk'
}

export const LANGUAGE_LABELS: Record<APP_LANGUAGE, string> = {
  [APP_LANGUAGE.EN]: 'ENGLISH',
  [APP_LANGUAGE.UK]: 'UKRAINIAN'
};

export enum EMPLOYEE_SYSTEM_STATUS {
  RESIGNED = 'RESIGNED',
  FIRED = 'FIRED',
  ONBOARDING = 'ONBOARDING'
}

export enum EMPLOYEE_ROLES {
  EMPLOYEE = 'EMPLOYEE',
  MANAGER = 'MANAGER',
  HR_MANAGER = 'HR_MANAGER',
  COMPANY_MANAGER = 'COMPANY_MANAGER',
  DEVICE_MANAGER = 'DEVICE_MANAGER',
  INFO_MANAGER = 'INFO_MANAGER'
}

export enum EMPLOYEE_AVAILABILITY {
  AVAILABLE = 'AVAILABLE'
}

export enum CALENDAR_EVENT_TYPE {
  SICK_LEAVE = 'SICK_LEAVE',
  VACATION = 'VACATION',
  HOLIDAY = 'HOLIDAY'
}

export enum CALENDAR_EVENT_STATUS {
  REQUESTED = 'REQUESTED',
  APPROVED = 'APPROVED',
  DECLINED = 'DECLINED'
}

export enum AUTHOR_TYPES {
  EMPLOYEE = 'EMPLOYEE',
  COMPANY = 'COMPANY',
  WORKFLOW = 'WORKFLOW'
}

export enum COMPANY_SETTINGS_TAB {
  INVENTORY = 'INVENTORY',
  EMPLOYEE = 'EMPLOYEE'
}

export enum COMPANY_SETTINGS_INSTANCE {
  INVENTORY_TYPE = 'INVENTORY_TYPE',
  INVENTORY_STATUS = 'INVENTORY_STATUS',
  EMPLOYEE_POSITION = 'EMPLOYEE_POSITION',
  EMPLOYEE_STATUS = 'EMPLOYEE_STATUS',
  EMPLOYEE_AVAILABILITY = 'EMPLOYEE_AVAILABILITY',
  EMPLOYEE_PROJECT = 'EMPLOYEE_PROJECT'
}

export enum COMPANY_SETTINGS_STSTEM_ID {
  CUSTOM = 'CUSTOM'
}

export enum VIDEO_TAG_LABELS {
  NEW = 'NEW',
  ALL = 'ALL'
}

export enum API_ERROR_TYPE {
  PERMISSION_DENIED = 'PERMISSION_DENIED'
}

export enum API_ERROR_REASON {
  EMAIL_LINK_REQUIRED = 'EMAIL_LINK_REQUIRED',
  EMPLOYEE_COMPANY_MISMATCH = 'EMPLOYEE_COMPANY_MISMATCH'
}

export enum KIDS_GENDER {
  MALE = 'MALE',
  FEMALE = 'FEMALE',
  PREFER_NOT_TO_SAY = 'PREFER_NOT_TO_SAY'
}

export enum SUBSCRIPTION_PLAN {
  SMALL = 'SMALL',
  MEDIUM = 'MEDIUM',
}

export enum LIQPAY_PAYMENT_STATUS {
  SUCCESS = 'success',
  FAILURE = 'failure',
  ERROR = 'error',
  SANDBOX = 'sandbox',
  SUBSCRIBED = 'subscribed',
  UNSUBSCRIBED = 'unsubscribed',
  WAIT_SECURE = 'wait_secure',
  WAIT_ACCEPT = 'wait_accept',
  PROCESSING = 'processing',
  REVERSED = 'reversed',
  HOLD_WAIT = 'hold_wait',
  HOLD_EXPIRED = 'hold_expired',
  CASH_WAIT = 'cash_wait',
  VERIFY_3DS = '3ds_verify',
  VERIFY_OTP = 'otp_verify',
  VERIFY_CVV = 'cvv_verify',
  VERIFY_SENDER = 'sender_verify',
  VERIFY_RECEIVER = 'receiver_verify',
  WAIT_LC = 'wait_lc',
  INVOICE_WAIT = 'invoice_wait',
  PREPARED = 'prepared',
  TRY_AGAIN = 'try_again',
}

export enum BILLING_STATUS {
  FREE_TRIAL = 'FREE_TRIAL',
  PAST_DUE = 'PAST_DUE',
  SUSPENDED = 'SUSPENDED',
  UNSUBSCRIBED = 'UNSUBSCRIBED',
  SMALL = 'SMALL',
  MEDIUM = 'MEDIUM',
  FREE = 'FREE',
  EARLY_ACCESS = 'EARLY_ACCESS'
}

export enum SUBSCRIPTION_STATUS {
  REQUESTED = 'requested',
  SUBSCRIBED = 'subscribed',
  UNSUBSCRIBED = 'unsubscribed'
}

export enum SUBSCRIPTION_EVENTS {
  CHANGED = 'CHANGED',
  UPGRADE = 'UPGRADE',
  UPGRADE_CONFIRMED = 'UPGRADE_CONFIRMED',
  DOWNGRADE = 'DOWNGRADE',
  DOWNGRADE_SCHEDULED = 'DOWNGRADE_SCHEDULED',
  CANCEL = 'CANCEL',
  CANCELLED = 'CANCELLED'
}

export enum SUBJECT {
  DEVICE = 'Device',
  EMPLOYEE = 'Employee',
  CALENDAR_DATE_LEAVE = 'CalendarDateLeave',
  CALENDAR_DATE_HOLIDAY = 'CalendarDateHoliday',
  NEWS_POST = 'NewsPost',
  COMPANY = 'Company',
  SUBSCRIPTION = 'Subscription',
  ALL = 'all'
}

export enum ACTION {
  MANAGE = 'manage',
  CREATE = 'create',
  VIEW = 'view',
  EDIT = 'edit',
  DELETE = 'delete'
}

export enum IPC_MESSAGE_TYPE {
  OIDC_SUCCESS = 'oidc-success',
  OIDC_FAILURE = 'oidc-failure'
}
